import { Icon, Layout, Text } from '@loadsmart/miranda-react'

import { isManualLocation, type Location } from '../../domain/Location'
import { formatLocationDate, formatLocationSource } from '../../presenters/locationPresenter'

export type LocationPingItemProps = {
  readonly location: Location
  onDeleteLocation: (locationUUID?: string) => void
}

export function LocationPingItem({ location, onDeleteLocation }: LocationPingItemProps) {
  return (
    <Layout.Stack paddingR="spacing-2">
      <Layout.Group justify="space-between">
        <Text variant="body-sm-bold">
          {location.city}, {location.state}
        </Text>
        {isManualLocation(location) && (
          <Icon
            name="trash"
            size="14px"
            color="color-text-tertiary"
            aria-label="delete manual location"
            onClick={() => onDeleteLocation(location.uuid)}
          />
        )}
      </Layout.Group>
      <Layout.Group justify="space-between">
        <Text variant="body-sm" color="color-text-secondary">
          {formatLocationDate(location)}
        </Text>
        <Layout.Group align="center" gap="spacing-0-5">
          <Icon name="pin-map" size="12x" color="color-text-tertiary" />
          <Text variant="body-sm" color="color-text-tertiary">
            {formatLocationSource(location)}
          </Text>
        </Layout.Group>
      </Layout.Group>
    </Layout.Stack>
  )
}
